module.exports = __webpack_public_path__ + "img/DSC_0053.d0ea1164.jpg";